import { observer } from "mobx-react";
import useStore from "../../../hooks/useStore";
import React, { useMemo } from "react";
import Select from "react-select";
import { generateYearArray } from "../../../utils/helpers";
import { useAuth } from "../../../context/authProvider";

const SetKpiFilter = ({ filters, setFilters }) => {
  const {
    companyStore: { fetchSetKpiTargetListRaw, companyDataJson },
  } = useStore();
const { showAlert } = useAuth();
  const categories = useMemo(
    () =>
      companyDataJson?.assignCategory?.map(
        ({ catId, catIdAssignCategory: { name } }) => ({
          value: catId,
          label: name,
        })
      ),
    [companyDataJson]
  );

  const subCategories = useMemo(
    () =>
      companyDataJson?.assignSubCategory
        ?.filter(({ catId }) =>
          !filters?.category ? true : filters?.category?.value === catId
        )
        ?.map(({ subCatId, subCatIdAssignSubCategory: { name } }) => ({
          value: subCatId,
          label: name,
        })),
    [companyDataJson?.assignSubCategory, filters?.category]
  );

  const kpis = useMemo(
    () =>
      companyDataJson?.assignKpi
        ?.filter(({ catId }) =>
          !filters?.category ? true : filters?.category?.value === catId
        )
        ?.filter(({ subCatId }) =>
          !filters?.subCategory
            ? true
            : filters?.subCategory?.value === subCatId
        )
        ?.map(({ kpiIdAssignKpi: { id, name } }) => ({
          value: id,
          label: name,
        })),
    [companyDataJson?.assignKpi, filters?.category, filters?.subCategory]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const { year, category, subCategory, kpi } = filters;
    if (!year) {
      showAlert("Please select Year.", false);
      return;
    }
    if (!category) {
      showAlert("Please select Category.", false);
      return;
    }
    if (!subCategory) {
      showAlert("Please select Sub Category.", false);
      return;
    }
    if (!kpi) {
      showAlert("Please select KPI.", false);
      return;
    }
    fetchSetKpiTargetListRaw({
      filter: {
        year,
        category: category.value,
        subCategory: subCategory.value,
        kpi: kpi.value,
      },
    });
  };

  const handleSelect = (value, key) => {
    setFilters((prev) => {
      const updated = { ...prev, [key]: value };

      if (key === "category") {
        updated.subCategory = null;
        updated.kpi = null;
      }

      if (key === "subCategory") {
        updated.kpi = null;
      }

      return updated;
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="card">
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-3">
              <label className="form-label">Year</label>
              <select
                className="form-select"
                name="year"
                value={filters?.year || ""}
                onChange={handleFilterChange}
              >
                <option value="">Select Year</option>
                {generateYearArray().map((val) => (
                  <option key={val} value={val}>
                    CY {val}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label className="form-label">Category</label>
              <Select
                isClearable
                name="category"
                value={filters?.category}
                options={categories}
                onChange={(e) => handleSelect(e, "category")}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">Sub Category</label>
              <Select
                isClearable
                name="subCategory"
                value={filters?.subCategory}
                options={subCategories}
                onChange={(e) => handleSelect(e, "subCategory")}
              />
            </div>

            <div className="col-md-3">
              <label className="form-label">KPI</label>
              <Select
                isClearable
                name="kpi"
                value={filters?.kpi}
                options={kpis}
                onChange={(e) => handleSelect(e, "kpi")}
              />
            </div>

            <div className="col-md-12 mt-3 text-end">
              <button type="submit" className="btn btn-primary">
                Search Filter
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default observer(SetKpiFilter);
